/**
 *  LANGUAGE FILE FOR DEUTCHE
 */

export default {
  title: "Demo der Lastwagen v1.0",
  nav: {
    home: "Zuhause",
    about: "Über",
    contact: "Kontakt"
  },
  search: {
    placeholder: "Suche nach Künstlern..."
  },
  events: {
    country: "Land",
    city: "Stadt",
    venue: "Tagungsort",
    date: "Datum",
    "upcomming-events": "Kommende Veranstaltungen",
    play_count: "Anzahl spielen"
  }
};
